// MUI palette configuration derived from the design tokens.
import { PaletteOptions } from '@mui/material';
import { ColorMode, getTokens } from './tokens';

/**
 * Build a MUI palette for the given color mode from the shared design tokens.
 * Only the slots MUI understands are mapped here; design-specific extras
 * (surface variants, tertiary text, status pill colors) live on `theme.tokens`.
 */
const getPalette = (mode: ColorMode): PaletteOptions => {
  const t = getTokens(mode);

  return {
    mode,
    primary: {
      main: t.accent,
      contrastText: t.onAccent,
    },
    secondary: {
      main: t.status.active.fg,
      contrastText: t.onAccent,
    },
    error: {
      main: t.status.failed.fg,
    },
    warning: {
      main: t.status.draft.fg,
    },
    info: {
      main: t.accent,
    },
    success: {
      main: t.status.active.fg,
    },
    background: {
      default: t.bg,
      paper: t.surface,
    },
    text: {
      primary: t.textPrimary,
      secondary: t.textSecondary,
      disabled: t.textTertiary,
    },
    divider: t.border,
  };
};

export default getPalette;
